<div class="flat-filter-header">
  <div class="container">

    <div class="row slider-row">
      <div class="col-12 col-md-4 field mb-4">
        <div class="custom-label">Max. ár: {{removeHuf(maxPriceValue | currency : 'HUF' : 'symbol' : '1.0-0')}} Forint</div>
        <div class="slidecontainer">
          <input type="range" [(ngModel)]="maxPriceValue" min="{{minPrice}}" max="{{maxPrice}}" step="1000000" class="slider">
        </div>
      </div>
      <div class="col-12 col-md-4 field mb-4">
        <div class="custom-label">Min. alapterület: {{minSizeValue}} m²</div>
        <div class="slidecontainer">
          <input type="range" [(ngModel)]="minSizeValue" min="{{minSize}}" max="{{maxSize}}" step="5" class="slider">
        </div>
      </div>
      <div class="col-12 col-md-4 field mb-4">
        <div class="custom-label">Szobák száma (min.): {{minNumberOfRoomsValue}}</div>
        <div class="slidecontainer">
          <input type="range" [(ngModel)]="minNumberOfRoomsValue" min="1" max="{{maxNumberOfRooms}}" step="1" class="slider">
        </div>
      </div>
    </div>

    <div class="row select-row">


      <div class="field col-12 col-md-4">

        <mat-form-field appearance="outline">
          <mat-label>Státusz</mat-label>
          <mat-select
            [(ngModel)]="selectedStatus"
            placeholder="Státusz">
            <mat-option *ngFor="let status of statusOptions" [value]="status">
              {{status.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>
      <div class="field col-12 col-md-4">

        <mat-form-field appearance="outline">
          <mat-label>Szint</mat-label>
          <mat-select
            [(ngModel)]="selectedLevelOption"
            placeholder="Szint">
            <mat-option *ngFor="let level of levelOptions" [value]="level">
              {{level.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>
      <div class="field col-12 col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Rendezés</mat-label>
          <mat-select
            [(ngModel)]="selectedSortOption"
            placeholder="Rendezés">
            <mat-option *ngFor="let sortOption of sortOptions" [value]="sortOption">
              {{sortOption.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

    </div>
  </div>

</div>

<div class="flat-page-container" *ngIf="flats">
  <div class="container">
    <div class="flat-list row px-3 px-lg-0">

      <ng-container *ngFor="let flat of getFlatList()">
        <div *ngIf="showFlat(flat)" class="flat-item-wrapper animated fadeIn col-12 col-sm-6">
        <span>
          <app-flat-preview-item [flat]="flat"></app-flat-preview-item>
        </span>
        </div>
      </ng-container>
    </div>

  </div>


</div>
